/* ACTION TYPE CONSTANTS*/

const LOAD_ALL_LOCATIONS = "app/locations/LOAD_ALL_LOCATIONS";
const LOAD_LOCATIONS = "app/locations/LOAD_LOCATIONS";
const LOAD_LOCATION = "app/locations/LOAD_LOCATION";
const JUMP_TO_CURRENT_LOCATION = "app/locations/JUMP_TO_CURRENT_LOCATION";

export {
    LOAD_ALL_LOCATIONS,
    LOAD_LOCATIONS,
    LOAD_LOCATION,
    JUMP_TO_CURRENT_LOCATION
};



// WEBPACK FOOTER //
// ./ducks/location-details/types.js